export default __webpack_public_path__ + "static/media/login.2309e5d4.webp";